import { console, Logger, toCause, toString } from '@studio/js-utils/logger';
import type { ILogger, Level, Message } from '@studio/js-utils/logger';
import { isNotNil } from '@tryiris-ai/js-types';
import { sentry } from './sentry/index.js';
import { DefaultMessage } from '#~/error/index.js';

/** Studio logger. */
export const logger: ILogger = new (class extends Logger {
  public log(level: Level, message: Message, ...args: unknown[]): this {
    // Never console log an entire stack trace.
    const [normalized, cause] =
      message instanceof Error
        ? [toString(message) ?? DefaultMessage, toCause(message.cause)]
        : [message, undefined];

    console.log(level, normalized, ...[cause, ...args].filter(isNotNil));

    // Send critical errors to Sentry.
    if (level === 'critical') {
      sentry.logEvent(message);
    }

    return this;
  }
})();
